/**
 * Created by Yoyo Fang on 08/12/19.
 * Description:
 * Singleton service wrapper of component factory, for easy create component on runtime.
 * ------ maintenance history ------
 */
import { Injectable, ComponentFactoryResolver, ViewContainerRef, ComponentFactory, ComponentRef, Type } from '@angular/core';

@Injectable()
export class DynamicComponentService {
    constructor(
        private _componentFactoryResolver: ComponentFactoryResolver
    ) {
    }

    loadComponent<T>(viewContainerRef: ViewContainerRef, componentType: Type<T>, replace: boolean = true): ComponentRef<T> {
        if (replace) {
            viewContainerRef.clear();
        }
        const componentFactory: ComponentFactory<T> = this._componentFactoryResolver.resolveComponentFactory(componentType);
        return viewContainerRef.createComponent(componentFactory);
    }
}
